import { useRouteLoaderData } from 'react-router';
import { idPublicTournamentIndex } from './layout';
import { CircleCheck, Lock } from 'lucide-react';

function Finished() {
  const { tournament } = useRouteLoaderData(idPublicTournamentIndex);
  const isInscriptionOnly = tournament?.mode === 'INSCRIPTION_ONLY';

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 py-12 text-center">
      <div className="rounded-full bg-neutral-100 p-4">
        {isInscriptionOnly ? (
          <Lock className="w-10 h-10 text-neutral-400" />
        ) : (
          <CircleCheck className="w-10 h-10 text-neutral-400" />
        )}
      </div>
      <h2 className="text-xl font-semibold">
        {isInscriptionOnly ? 'Inscripciones cerradas' : 'Torneo finalizado'}
      </h2>
      <p className="text-muted-foreground text-sm max-w-xs">
        {isInscriptionOnly
          ? 'Este torneo ya cerro sus inscripciones. Gracias por tu interes.'
          : 'Este torneo ya ha finalizado. Gracias por participar.'}
      </p>
    </div>
  );
}

export const route = {
  index: true,
  path: 'finished',
  element: <Finished />,
};
